var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_45",
    "data-name": "Komponente 10 \\u2013 45",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.997,
    height: 58,
    viewBox: "0 0 57.997 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "work-in-progress",
    transform: "translate(-0.013 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46869",
    "data-name": "Pfad 46869",
    d: "M49.557,8.46C39.433-2.064,21.617-2.864,10.527,6.591A.851.851,0,1,0,11.611,7.9,27.392,27.392,0,0,1,28.163,1.667v5.11A22.273,22.273,0,0,0,6.786,28.153H1.677A27.314,27.314,0,0,1,8.514,10.9.851.851,0,0,0,7.238,9.773C-2.849,20.8-2.315,39.181,8.47,49.547c10.814,11.271,30.273,11.27,41.087,0,11.271-10.814,11.27-30.273,0-41.087Zm-1.2,39.883c-10.181,10.611-28.5,10.61-38.679,0a27.158,27.158,0,0,1-8-18.488h5.11c.5,17.639,21.431,27.731,35.516,16.977a.851.851,0,0,0-1.019-1.363C28,55.591,8.33,45.7,8.473,29A20.564,20.564,0,0,1,29.014,8.463C46.48,8.339,56.078,29.5,44.456,42.533a.851.851,0,0,0,1.28,1.123C58.088,29.83,48.316,7.318,29.865,6.776V1.666C53.664,2.342,65.237,31.55,48.353,48.343Z",
    transform: "translate(0 0)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46870",
    "data-name": "Pfad 46870",
    d: "M134.072,190.751a.851.851,0,0,0-.713-.386h-6.982a.851.851,0,1,0,0,1.7h5.678L127,203.565a.852.852,0,0,0,1.558.685l5.579-12.691A.851.851,0,0,0,134.072,190.751Z",
    transform: "translate(-111.269 -168.761)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46871",
    "data-name": "Pfad 46871",
    d: "M203.435,197.341a7.348,7.348,0,0,0-1.566.144l.591-3.566h4.047a.851.851,0,0,0,0-1.7h-4.768a.851.851,0,0,0-.84.712l-.945,5.7c-.138.831.743,1.112,1.354.837,2.2-1.062,5.165-.18,5.154,2.768a3.03,3.03,0,0,1-6.057-.162.851.851,0,0,0-1.7,0,4.783,4.783,0,0,0,4.83,4.732A4.733,4.733,0,0,0,203.435,197.341Z",
    transform: "translate(-176.14 -170.403)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46872",
    "data-name": "Pfad 46872",
    d: "M314.4,191.936a.851.851,0,0,0-1.114.456l-5.264,12.542a.852.852,0,0,0,1.57.659l5.264-12.542A.851.851,0,0,0,314.4,191.936Z",
    transform: "translate(-272.991 -170.095)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46873",
    "data-name": "Pfad 46873",
    d: "M296.8,194.585a2.6,2.6,0,0,0-2.454-2.714c-3.25.132-3.249,5.3,0,5.428a2.6,2.6,0,0,0,2.454-2.714Zm-3.206,0c.049-1.338,1.455-1.338,1.5,0C295.048,195.923,293.642,195.923,293.593,194.585Z",
    transform: "translate(-258.769 -170.096)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46874",
    "data-name": "Pfad 46874",
    d: "M347.375,272.274a2.6,2.6,0,0,0-2.454-2.714c-3.25.132-3.249,5.3,0,5.428A2.6,2.6,0,0,0,347.375,272.274Zm-2.454,1.012c-.992-.058-.992-1.965,0-2.023C345.913,271.32,345.913,273.228,344.921,273.285Z",
    transform: "translate(-303.605 -238.968)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46875",
    "data-name": "Pfad 46875",
    d: "M82.638,56.987A25.688,25.688,0,0,0,60.561,31.609a.852.852,0,0,0-.283,1.679,23.986,23.986,0,0,1,20.657,23.7c0,.007,0,.014,0,.021s0,.014,0,.021A23.982,23.982,0,0,1,57.011,80.955h-.042A23.986,23.986,0,0,1,33.269,60.3a.852.852,0,0,0-1.68.281A25.688,25.688,0,0,0,56.967,82.658h.045A25.687,25.687,0,0,0,82.638,57.032c0-.007,0-.015,0-.022S82.638,56.994,82.638,56.987Z",
    transform: "translate(-27.976 -28.006)",
    fill: "#a5b5af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.8160b18e5172191e63e96515f28b0ecc.svg";
export { ForwardRef as ReactComponent };